import { BaseIcon, BaseIconProps } from './BaseIcon';

const ArrowSimpleRightIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props}>
      <path d="M9 20L17 12L9 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </BaseIcon>
  );
};

export default ArrowSimpleRightIcon;
